(function ($) {
  "use strict";
  jQuery(document).ready(function() {
    // menu toggler js
    $("button.navbar-toggle").on('click', function() {
      $(".main-menu-area").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("ov-hidden");
    });
    $(".close-box").on('click', function() {
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("ov-hidden");
    });

    // filter button js
    $("button.filter-button").on('click', function() {
      $(".filter-sidebar").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
    });
    $("button.close-filter-sidebar").on('click', function() {
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
    });

    // body background color js
    $(".mm-fullscreen-bg").on('click',function() {
      $(".main-menu-area").removeClass("active");
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });
    $('.checkout-btn .read-agree').on('click', function () {
      if($('.cust-checkbox').is(':checked')) {
        $('.checkout-btn button.check-btn').removeAttr('disabled');
      }
      else {
        $('.checkout-btn button.check-btn').attr('disabled', 'disabled');
      }
    });
    $('.read-agree').on('click', function () {
      if($('.create-checkbox').is(':checked')) {
        $('.create').removeAttr('disabled');
      }
      else {
        $('.create').attr('disabled', 'disabled');
      }
    });
    // Product flyout: level 2/3 panels live outside scroll containers (desktop only)
    var productFlyoutTimer = null;
    function getProductFlyoutLevel2Panel($li) {
      var panelId = $li.attr('data-level2-panel');
      if (!panelId) return $();
      return $('#' + panelId);
    }
    function isWithinProductFlyoutTarget(target) {
      if (!target) return false;
      return $(target).closest('.product-flyout-menu, .productsupmenu-dropdown, .level-3-container, .level-3-flyout').length > 0;
    }
    function getProductFlyoutDropdown($row) {
      return $row.closest('.productsupmenu-dropdown');
    }
    function getProductFlyoutLevel3Panel($dropdown, panelId) {
      if (!panelId || !$dropdown.length) return $();
      return $dropdown.find('.level-3-container > .level-3-flyout').filter(function() {
        return this.id === panelId;
      });
    }
    function isRtlLayout() {
      return document.documentElement.getAttribute('dir') === 'rtl';
    }
    function resetProductFlyoutLevel3Panel($panel) {
      $panel.removeClass('is-flyout-open is-flyout-fixed').css({
        top: '',
        left: '',
        right: '',
        position: '',
        width: '',
        zIndex: ''
      });
    }
    function getFlyoutTop($target, $container) {
      var targetRect = $target[0].getBoundingClientRect();
      var containerRect = $container[0].getBoundingClientRect();
      return targetRect.top - containerRect.top;
    }
    function positionProductFlyoutLevel2($li) {
      var $menu = $li.closest('.product-flyout-menu');
      var $panel = getProductFlyoutLevel2Panel($li);
      if (!$menu.length || !$panel.length) return;
      $menu.find('.product-flyout-level2-panels .productsupmenu-dropdown.is-flyout-open').not($panel)
        .removeClass('is-flyout-open').css('top', '');
      $panel.css('top', getFlyoutTop($li, $menu) + 'px').addClass('is-flyout-open');
      fitProductFlyoutLevel2Scroll($li, $panel);
    }
    function clearProductFlyoutLevel2($menu) {
      $menu.find('.product-flyout-level2-panels .productsupmenu-dropdown.is-flyout-open')
        .removeClass('is-flyout-open').css('top', '');
    }
    function positionProductFlyoutLevel3($row) {
      var $dropdown = getProductFlyoutDropdown($row);
      var panelId = $row.attr('data-level3-panel');
      if (!panelId || !$dropdown.length) return;
      var $panel = getProductFlyoutLevel3Panel($dropdown, panelId);
      if (!$panel.length) return;
      var rowRect = $row[0].getBoundingClientRect();
      var dropdownRect = $dropdown[0].getBoundingClientRect();
      var panelWidth = $panel.outerWidth() || 280;
      var rtl = isRtlLayout();
      $dropdown.addClass('is-flyout-open');
      $dropdown.find('.level-3-flyout.is-flyout-open').not($panel).each(function() {
        resetProductFlyoutLevel3Panel($(this));
      });
      $panel.css({
        position: 'fixed',
        top: rowRect.top + 'px',
        left: rtl ? (dropdownRect.left - panelWidth) + 'px' : (dropdownRect.right - 1) + 'px',
        right: 'auto',
        width: panelWidth + 'px',
        zIndex: 100000
      }).addClass('is-flyout-open is-flyout-fixed');
    }
    function clearProductFlyoutLevel3($dropdown) {
      $dropdown.find('.level-3-flyout.is-flyout-open').each(function() {
        resetProductFlyoutLevel3Panel($(this));
      });
    }
    function fitProductFlyoutLevel2Scroll($li, $dropdown) {
      $dropdown = $dropdown || getProductFlyoutLevel2Panel($li);
      var $scroll = $dropdown.find('.level-2-scroll');
      if (!$scroll.length) return;
      var viewportBottom = $(window).scrollTop() + $(window).height();
      var panelTop = $dropdown.offset().top;
      var available = viewportBottom - panelTop - 24;
      var maxHeight = Math.min(available, $(window).height() - 120);
      maxHeight = Math.max(maxHeight, 160);
      $scroll.css('max-height', maxHeight + 'px');
    }
    function resetProductFlyoutLevel2Scroll($dropdown) {
      $dropdown.find('.level-2-scroll').css('max-height', '');
    }
    function fitProductFlyoutLevel1Scroll($menuLink) {
      var $scroll = $menuLink.find('.product-flyout-menu > .level-1-scroll');
      if (!$scroll.length) return;
      var viewportBottom = $(window).scrollTop() + $(window).height();
      var menuTop = $menuLink.offset().top;
      var available = viewportBottom - menuTop - 24;
      var maxHeight = Math.min(available, $(window).height() - 160);
      maxHeight = Math.max(maxHeight, 200);
      $scroll.css('max-height', maxHeight + 'px');
    }
    function resetProductFlyoutLevel1Scroll($menuLink) {
      $menuLink.find('.product-flyout-menu > .level-1-scroll').css('max-height', '');
    }
    function relocateProductFlyoutLevel2Panels() {
      var isDesktop = window.matchMedia('(min-width: 1200px)').matches;
      $('.product-flyout-menu').each(function() {
        var $menu = $(this);
        var $container = $menu.find('.product-flyout-level2-panels');
        clearProductFlyoutLevel2($menu);
        $menu.find('.productsupmenu-dropdown').each(function() {
          clearProductFlyoutLevel3($(this));
          resetProductFlyoutLevel2Scroll($(this));
        });
        $menu.find('.productlink-li--has-children').each(function() {
          var panelId = $(this).attr('data-level2-panel');
          var $panel = $('#' + panelId);
          if (!$panel.length) return;
          if (isDesktop) {
            $container.append($panel);
          } else {
            $(this).append($panel);
          }
        });
      });
    }
    function initProductFlyoutLevel3() {
      $(document).off('.productFlyout');
      $(window).off('resize.productFlyout');
      relocateProductFlyoutLevel2Panels();
      $(window).on('resize.productFlyout', relocateProductFlyoutLevel2Panels);
      if (!window.matchMedia('(min-width: 1200px)').matches) return;
      $(document).on('mouseenter.productFlyout', '.menu-link:has(.product-flyout-menu)', function() {
        fitProductFlyoutLevel1Scroll($(this));
      });
      $(document).on('mouseleave.productFlyout', '.menu-link:has(.product-flyout-menu)', function(e) {
        var $menuLink = $(this);
        if (e.relatedTarget && $menuLink[0].contains(e.relatedTarget)) return;
        resetProductFlyoutLevel1Scroll($menuLink);
      });
      $(document).on('mouseenter.productFlyout', '.product-flyout-menu .productlink-li--has-children', function() {
        clearTimeout(productFlyoutTimer);
        positionProductFlyoutLevel2($(this));
      });
      $(document).on('mouseenter.productFlyout', '.product-flyout-level2-panels .productsupmenu-dropdown', function() {
        clearTimeout(productFlyoutTimer);
        $(this).addClass('is-flyout-open');
      });
      $(document).on('mouseenter.productFlyout', '.productsupmenu-dropdown .productsupmenu-li--has-children', function() {
        clearTimeout(productFlyoutTimer);
        positionProductFlyoutLevel3($(this));
      });
      $(document).on('mouseenter.productFlyout', '.productsupmenu-dropdown .level-3-container, .productsupmenu-dropdown .level-3-flyout', function() {
        clearTimeout(productFlyoutTimer);
        var $target = $(this);
        var $dropdown = $target.closest('.productsupmenu-dropdown');
        $dropdown.addClass('is-flyout-open');
        if ($target.hasClass('level-3-flyout')) {
          $target.addClass('is-flyout-open');
        }
        var $activeRow = $dropdown.find('.productsupmenu-li--has-children:hover');
        if ($activeRow.length) {
          positionProductFlyoutLevel3($activeRow);
        }
      });
      $(document).on('mouseleave.productFlyout', '.product-flyout-menu', function(e) {
        var $menu = $(this);
        if (e.relatedTarget && ($menu[0].contains(e.relatedTarget) || isWithinProductFlyoutTarget(e.relatedTarget))) return;
        clearTimeout(productFlyoutTimer);
        productFlyoutTimer = setTimeout(function() {
          clearProductFlyoutLevel2($menu);
          $menu.find('.productsupmenu-dropdown').each(function() {
            clearProductFlyoutLevel3($(this));
            resetProductFlyoutLevel2Scroll($(this));
          });
        }, 150);
      });
      $(document).on('scroll.productFlyout', '.productsupmenu-dropdown .level-2-scroll', function() {
        var $active = $(this).find('.productsupmenu-li--has-children:hover');
        if ($active.length) {
          positionProductFlyoutLevel3($active);
        }
      });
      $(document).on('scroll.productFlyout', '.product-flyout-menu .level-1-scroll', function() {
        var $active = $(this).find('.productlink-li--has-children:hover');
        if ($active.length) {
          positionProductFlyoutLevel2($active);
        }
      });
    }
    initProductFlyoutLevel3();
    $(window).on('resize.productFlyoutInit', initProductFlyoutLevel3);

    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    });
    
    // product-img full-view & magnific popup
    $('.full-view, .zoom').on('click', function() {
      $('.product_img_top').magnificPopup({
        delegate: 'a',
        type:'image',
        showCloseBtn: true,
        closeBtnInside: false,
        midClick: true,
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0,1]
        }
      }).magnificPopup('open');
    });
    $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
      tClose: 'Close (Esc)',
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
    $('.item-data').on("click", function() {
      $(this).parents('.option-block').find(".variant-option").removeClass('active-variant');
      $(this).closest('form-wrap').addClass('active-variant');
      var it_img = $(this).attr('dataimg');
      $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('src',it_img);
      $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('srcset',it_img);
      var price = $(this).attr('dataprice');
      var compareprice = $(this).attr('datacompare');
      var stocks = $(this).attr('dataavailable');
      $(this).parents('.single-product-wrap').find('.price-box .new-price').text(Shopify.formatMoney(price, window.money_format));
      if (compareprice > price) {
        $(this).parents('.single-product-wrap').find('.price-box .old-price').show();
        $(this).parents('.single-product-wrap').find('.price-box .old-price').html(Shopify.formatMoney(compareprice, window.money_format));
      }else{
        $(this).parents('.single-product-wrap').find('.price-box .old-price').hide();
      }
    });
    var swiper = new Swiper('.drawer-slider', {
      slidesPerView: 1,
      grid: {
        rows: 1,
        fill: 'row' | 'column',
      },
      spaceBetween: 30,
      navigation: {
        nextEl: '.arrow-next-drawer',
        prevEl: '.arrow-prev-drawer',
      },
      autoplay: {
      delay: 5000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true
      },
      speed: 1000,
    });
  });
})(jQuery);